import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Select, Option } from 'barnyard/components';
import { daysOfTheWeek } from '~/app/common/constants/utils';


const DayOfWeekSelect = props => (
  <Select
    {...props}
  >
    {_.map(daysOfTheWeek, value => (
      <Option key={value.value} value={value.value}>
        {value.label}
      </Option>
    ))}
  </Select>
);

DayOfWeekSelect.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  mode: PropTypes.string,
};

export default DayOfWeekSelect;
